export const blockIconsNavigationCancel = (
	<span className='material-symbols-outlined'>cancel</span>
);
